module.exports = __webpack_public_path__ + "img/motion-icon.cdc750c9.png";